export const TEMPLATES = {
  US_HOSPITAL: 1,
  UK_HOSPITAL: 2,
  BUSINESS: 3
};
